import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "@/components/landing/primitives";
import { ECOSYSTEM_LAYERS } from "@/data/content";

const TONES = { gold: "var(--gold-2)", cyan: "var(--cyan)", emerald: "var(--emerald)" };

export default function EcosystemSection() {
  return (
    <section id="ecosystem" className="relative py-20 md:py-28 scroll-mt-24" data-testid="section-ecosystem">
      <div className="absolute inset-0 grid-lines opacity-30" />
      <div className="container-trt relative z-10">
        <SectionHeading
          eyebrow="System Architecture"
          title="One connected"
          highlight="TRT ecosystem"
          sub="Every layer of TRT interlocks — from the base chain to the investor dashboard — creating a single, composable stack for tokenized real-world assets."
        />

        <div className="mt-16 max-w-3xl mx-auto flex flex-col gap-4">
          {ECOSYSTEM_LAYERS.map((layer, i) => {
            const color = TONES[layer.tone];
            return (
              <Reveal key={layer.name} delay={i * 0.08}>
                <div className="relative">
                  <div
                    className="glass rounded-2xl px-6 py-5 card-hover flex items-center justify-between gap-4"
                    style={{ marginLeft: `${i * 6}%`, marginRight: `${i * 6}%` }}
                  >
                    <div className="flex items-center gap-4">
                      <span className="font-mono text-xs text-[var(--muted-2)]">L{i + 1}</span>
                      <span
                        className="w-2.5 h-2.5 rounded-full"
                        style={{ background: color, boxShadow: `0 0 14px ${color}` }}
                      />
                      <div>
                        <div className="font-display font-bold text-lg">{layer.name}</div>
                        <div className="text-xs text-[var(--muted)] font-mono">{layer.note}</div>
                      </div>
                    </div>
                    <span className="hidden sm:block text-[10px] font-mono tracking-widest px-3 py-1 rounded-full" style={{ color, border: `1px solid ${color}44` }}>
                      LAYER {i + 1}
                    </span>
                  </div>
                  {i < ECOSYSTEM_LAYERS.length - 1 && (
                    <div className="mx-auto w-px h-4 bg-gradient-to-b from-[var(--gold-3)]/50 to-transparent" />
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
